import React, { useState } from "react";

import { Plus, DownMinimalArrow } from "icons";

import {
  Button,
  Checkbox,
  DropdownOverlay,
  SearchBar,
  Table,
  Typography,
} from "clearsense-ui/components";
import ExploreContainer from "components/Common/ExploreContainer";
import PermissibleWrapper from "components/Common/PermissibleWrapper";
import { useUserState } from "contexts/user";
import { useColumnHeaderSelector } from "hooks/useColumnHeaderSelector";
import { getPermissions } from "utils/roleBasedAccess";

import AssociatePeople from "./AssociatePeople";

import { PEOPLE_COLUMNS, PEOPLE_DATA } from "../../constants/peopleExplore";
import SummaryCard from "../SummaryCard";

const People = ({ features, cde }) => {
  const user = useUserState();
  const userPermissions = getPermissions(features, user?.role);

  const { columns, toggleVisibility } = useColumnHeaderSelector(PEOPLE_COLUMNS);

  const [isPaneOpen, setIsPaneOpen] = useState(false);

  return (
    <ExploreContainer>
      <div className="flex justify-between">
        <Typography style="h3" type="semibold">
          People
        </Typography>
        <Typography style="h3" type="semibold">
          Summary
        </Typography>
        <PermissibleWrapper
          currentPermissions={userPermissions}
          acceptablePermissions="associate"
        >
          <Button
            label="Associate People"
            icon={Plus}
            primaryAction={() => {}}
            data-cy="associate-people-button"
          />
        </PermissibleWrapper>
      </div>
      <SummaryCard cde={cde} />
      <div className="flex items-center justify-between mt-8">
        <div className="flex items-center gap-8">
          <Typography style="large" type="bold">
            5 People
          </Typography>
          <Button
            label="Add Filter"
            className="flex-shrink-0"
            icon={Plus}
            style="secondary"
          />
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <SearchBar className="ml-2" />
          <DropdownOverlay
            buttonLabel="Edit Columns"
            buttonStyle="secondary"
            icon={DownMinimalArrow}
            buttonProps={{ icon: DownMinimalArrow, iconPosition: "right" }}
          >
            <div className="p-4 pb-0">
              <Typography
                style="h6"
                className="mb-2 uppercase text-grey-medium-shade"
              >
                enabled
              </Typography>
              {columns?.selected?.map(column => (
                <Checkbox
                  key={column.key}
                  label={column.title}
                  id={column.key}
                  className="mb-5"
                  onClick={e =>
                    columns.selected.length > 1 && toggleVisibility(e.target.id)
                  }
                  checked
                  readOnly
                  disabled={columns.selected.length === 1}
                />
              ))}
            </div>
            <div className="px-4">
              <Typography
                style="h6"
                className="mb-2 uppercase text-grey-medium-shade"
              >
                disabled
              </Typography>
              {columns?.unSelected?.map(column => (
                <Checkbox
                  key={column.key}
                  label={column.title}
                  id={column.key}
                  className="mb-5"
                  onClick={e => toggleVisibility(e.target.id)}
                  readOnly
                />
              ))}
            </div>
          </DropdownOverlay>
        </div>
      </div>
      <div className="mt-8">
        <Table rowData={PEOPLE_DATA} columnData={columns.selected} />
      </div>
      <AssociatePeople isPaneOpen={isPaneOpen} setIsPaneOpen={setIsPaneOpen} />
    </ExploreContainer>
  );
};

export default People;
